module.exports = __webpack_public_path__ + "static/room-e23b9d3affe6651a46d323118eaa10c4.jpg";